import { z } from "zod";

import { ibanSchema } from "@/lib/validation/commission.schemas";

export const generalSettingsSchema = z.object({
  name: z.string().min(1, { error: "نام فروشگاه الزامی است" }),
  category: z.string().optional(),
  business_type: z.string().optional(),
  description: z.string().optional(),
  warehouse_address: z.string().optional(),
  iban: ibanSchema,
});

export type GeneralSettingsFormValues = z.infer<typeof generalSettingsSchema>;

export const teamInviteSchema = z.object({
  phone: z
    .string()
    .min(1, { error: "شماره موبایل الزامی است" })
    .regex(/^09\d{9}$/, { error: "شماره موبایل باید با 09 شروع و ۱۱ رقم باشد" }),
  role_id: z.number().min(1, { error: "نقش الزامی است" }),
});

export type TeamInviteFormValues = z.infer<typeof teamInviteSchema>;

export const shippingSettingsSchema = z
  .object({
    shipping_post: z.boolean(),
    shipping_courier: z.boolean(),
    shipping_pickup: z.boolean(),
    sms_order_confirm: z.boolean(),
    sms_tracking: z.boolean(),
    sms_status_update: z.boolean(),
  })
  .refine((values) => values.shipping_post || values.shipping_courier || values.shipping_pickup, {
    error: "حداقل یک روش ارسال باید فعال باشد",
    path: ["shipping_post"],
  });

export type ShippingSettingsFormValues = z.infer<typeof shippingSettingsSchema>;

export const socialValuesSchema = z.record(z.string(), z.string());

export type SocialValuesForm = z.infer<typeof socialValuesSchema>;

export const scheduleDeleteSchema = z.object({
  confirmName: z.string().min(1, { error: "نام فروشگاه را وارد کنید" }),
});

export type ScheduleDeleteFormValues = z.infer<typeof scheduleDeleteSchema>;
